import React from 'react';
const benefits = [{
  emoji: '🌿',
  title: 'Ingredientes 100% Naturales',
  description: 'Hierbas que consigue en cualquier feria o herboristería de Uruguay'
}, {
  emoji: '⚡',
  title: 'Resultados en 7 Días',
  description: 'Muchos usuarios reportan mejoras medibles en la primera semana'
}, {
  emoji: '🥩',
  title: 'Sin Dejar el Asado',
  description: 'No le pedimos que abandone lo que disfruta. Le enseñamos a manejarlo'
}, {
  emoji: '💊',
  title: 'Sin Dependencia de Fármacos',
  description: 'Un complemento natural que trabaja con su cuerpo, no contra él'
}, {
  emoji: '🧠',
  title: 'Fácil de Seguir',
  description: 'Instrucciones paso a paso, sin complicaciones ni tecnicismos'
}, {
  emoji: '🛡️',
  title: 'Garantía Total',
  description: 'Si no ve resultados en 7 días, le devolvemos cada peso'
}];
export function BenefitsSection() {
  return <section className="py-16 px-4 bg-white" data-id="element-8">
      <div className="max-w-5xl mx-auto" data-id="element-9">
        <div className="text-center mb-12" data-id="element-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-11">
            Los Beneficios del Protocolo
          </h2>
          <div className="h-1 w-24 bg-emerald-500 mx-auto rounded-full" data-id="element-12"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-13">
          {benefits.map((benefit, index) => <div key={index} className="bg-emerald-50 rounded-2xl p-6 border border-emerald-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-14">
              <div className="text-4xl mb-4" data-id="element-15">{benefit.emoji}</div>
              <h3 className="font-bold text-gray-900 text-lg mb-2" data-id="element-16">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-17">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}